/* LAST VIEWED PRODUCT */
var CUBE = CUBE || {};

(function($) {
	"use strict";

  var tcVars = window.tc_vars || {};
	var CUBE = window.CUBE || {};
	var fwk = (CUBE.Anly ? CUBE.Anly : { Anly: { utils: { isVisible: () => false }} });
	var lvpConfig = {};
	var ajaxURL = "/" + tcVars.env_language + "/ajax/retrieveProductModels?productId=";
	var isDirectAddToCart = true;
	var isDashboard = false;
	var customParams = "&customParams=";

	fwk.perso = fwk.perso || {};

	fwk.perso.lvp = {

		init: function() {

			if ($('#perso-lvp-list, #perso-lvp-grid').length === 0)
				return;

			if (tcVars.page_name === '/account/dashboard')
				isDashboard = true;

			if ($('#perso-lvp-grid').length) {
				// GRID MODE : MY HISTORY LVP > NO SLIDER
				isDirectAddToCart = false;
				$('#perso-lvp-grid .product').each(this.loadLVPGrid);
        lvpConfig.targetBlank = $('#perso-lvp-grid').data('target-blank');

			} else {
				// LIST MODE : OTHER PAGES > SLIDER NEEDED
				lvpConfig = $('#lvp-slick-config').data();
				this.initSlider();
				this.initDirectAddToCart();

				// Load displayed elements
				if (!isDashboard)
					$('.lvp-element.new.slick-active').removeClass('new').each(this.fetchLVP());
			}

		},

		fetchLVP: function() {
			if (isDirectAddToCart)
				return this.loadFullLVP;
			else
				return this.loadLVP;
		},

		initSlider: function() {
			// Init global-slider
			if (!isDashboard)
				$('#perso-lvp-list').slick(this.config.slider.slickConfGlobal(lvpConfig));
			else
				$('.lvp-element.new').removeClass('new').each(fwk.perso.lvp.loadLVP);

			$('#perso-lvp-list').on('afterChange', function(event, slick) {
				// Load all new element
				if (slick.$slider.attr('id') == 'perso-lvp-list') {
					updateAllSubSliders();
					$('.lvp-element.new').removeClass('new').each(fwk.perso.lvp.fetchLVP());
				}
			});

		},
		getModel: function($product) {
			return {
				id: $product.attr('data-model-id'),
				name: $product.find('h2.name').text(),
				brand: $product.find('.brand').text(),
				list: fwk.utils.getInfoNavFromURL(),
				position: ($('.lvp-product').index($product) + 1),
				price: $product.find('[data-price]').data('price'),
				variant: '',
				category: '',
				type: 'lvp'
			};
		},

		initDirectAddToCart: function() {
			// Init sliders
			$('.slider-products').slick(this.config.slider.slickConfHeadProducts);
			$('.slider-models').slick(this.config.slider.slickConfModels);

			$('.slider-models').on('beforeChange', modelBeforeChange);
			$('.slider-models').on('afterChange', handleDisableAddToCart);

			/*
			 * IN CASE OF 'DIRECT-ADD-TO-CART' :
			 *	> Links are disabled
			 *	> Hoverring LVP opens details (Colors, sizes) and displays an add to cart button
			 *	> On mobile, clicking LVP opens a modal window with direct add to cart button
			 *
			 * Each time the mouse is over an LVP product, displays the LVP-details panel
			 */
			 var tOut = [];
			 if (!$('body').hasClass('mobile')) {
				 // Desktop
				$('#perso-lvp-list .lvp-element').hover(function() {
					// SHOW MODELS + SIZES
					var $lvp = $(this);
					var refId = $lvp.data('sku-id');
					clearTimeout(tOut[refId]);

					$lvp.find('.lvp-more-products').slideDown(200);
					$lvp.find('.slider-models').slick('setPosition');
					$lvp.find('.lvp-size[data-sku-id="'+refId+'"]').closest('.slider-sizes').slick('setPosition');

					}, function() {
					// HIDE MODELS + SIZES
					var refId = $(this).data('sku-id');
					tOut[refId] = setTimeout(function() { $(this).find('.lvp-more-products').slideUp(200); }.bind(this), 200);
				});
			 } else {
				 // Mobile
				 var oldIndex = 0;
				$('#perso-lvp-list .lvp-element:not(.lvp-popin)').on('click', function(event) {
					var $lvp = $(this);
					if ($lvp.hasClass('lvp-popin')) return;

					//Stop propagation when display popup only
					event.preventDefault();
					event.stopPropagation();

					// ADD BACKDROP
					$lvp.closest('#perso-lvp-list').wrap('<div class="backdrop-lvp"></div>');

					// ADD POPIN classe to current LVP
					$lvp.addClass('lvp-popin');
					// ADD POPUNDER classe to other LVP
					$lvp.closest('.slick-track').find('.lvp-element:not(.lvp-popin)').addClass('lvp-popunder');

					// Set Slick Slider to go on the good slide
					oldIndex = $lvp.data('slick-index');
					$lvp.closest('.slick-slider').slick('slickSetOption', 'speed', 0).slick('slickGoTo', 1);

					// DISPLAYS CURRENT LVP OPTIONS
					var refId = $lvp.data('sku-id');
					$lvp.find('.lvp-more-products').show();
					$lvp.find('.slider-models').slick('setPosition');
					$lvp.find('.lvp-size[data-sku-id="'+refId+'"]').closest('.slider-sizes').slick('setPosition');

					// Make LVP clickable
					_wrapLink($lvp);

					// ! \\ HACK LVP / FOOTER ; When popin is UP :
					// - stop scrool
					$('.m-breadcrumbs').css('z-index', '1000');
					$(window).on('mousewheel.popin DOMMouseScroll.popin', function(e) {
						e.stopPropagation();
						e.preventDefault();
					});

					// REMOVE BACKDROP
					$('.backdrop-lvp').on('click', function(e) {


						// If CLICK is on product, return 'true' to keep event going;
						// And bubble-up to the .clickable-area element en trigger link's redirection
						var isClickOnProduct = $(e.target).closest('.lvp-product').length > 0;
						if (isClickOnProduct)
							return true;

						// If CLICK is inside the popin, exit 'closing function'
						var isClickOnBackdrop = $(e.target).closest('.lvp-element').length === 0 || $(e.target).hasClass('lvp-close');
						if (!isClickOnBackdrop)
							return false;

						// IF LIST-LVP is inside backdrop, remove it
						if ($('#perso-lvp-list').parent().is('.backdrop-lvp'))
							$('#perso-lvp-list').unwrap();

						// HIDE LVP OPTIONS
						$lvp.find('.lvp-more-products').hide();

						// REMOVE CLASSES 'POPIN' & 'POPUNDER'
						$('.lvp-element.lvp-popin').removeClass('lvp-popin');
						$('.lvp-element.lvp-popunder').removeClass('lvp-popunder');

						$('#perso-lvp-list').slick('slickGoTo', oldIndex).slick('slickSetOption', 'speed', 300);

						// Unwrap click-area link to go on product page
						$('.clickable-area').children().unwrap();

						// ! \\ HACK - LVP / FOOTER
						// - Remove 'stop scroll'
						$('.m-breadcrumbs').css('z-index', '1400');
						$(window).off('mousewheel.popin DOMMouseScroll.popin');
					});

				});
			 }

		},

		loadLVPGrid: function() {
			// Remove LVP without URL
			$('.lvp-element[data-default-url="/"]').remove();
			var $currentLVP = $(this);
			var superModelId = $currentLVP.data('super-model-id');
      var skuId = $currentLVP.data('sku-id');
      var customPriceParams = encodeURI($currentLVP.data('price-params'));


			$.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajaxURL + superModelId + customParams + customPriceParams,
				success: function(data) {
					var found = false;
					if (data.responseTO.errors.length) return console.warn('Error while loading LVP list');
					data.responseTO.data.map(function(model) {
						if (model.skus) {
							model.skus.map(function(sku) {
								// refSku = currentSku => Model Found !
								if (sku.id == skuId) {
									found = true;
									var modelId = model.id;
									var name = model.media.images[0].name;
									var url = model.media.images[0].url;
									$currentLVP.find('.img-product img').attr('src', url);
									$currentLVP.find('.img-product img').attr('alt', name);
									$currentLVP.find('.img-product a').attr('href', $currentLVP.data('default-url'));
									$currentLVP.find('.title a').attr('href', $currentLVP.data('default-url'));
									$currentLVP.attr('data-model-id', modelId);

									// Include PRICE
									if (sku.displayPriceContainer)
										$currentLVP.find('.price-container').replaceWith($(sku.displayPriceContainer));
								}
							});
						}
					});
					if (!found)$currentLVP.remove();
					// Hide Price Duration Inforation (Buggy-non-translated message)
					$('.info-duration').hide();

				}
			});

		},

		loadLVP: function() {
			var $currentLVP = $(this);
			var superModelId = $currentLVP.data('super-model-id');
			var refModelId = '';//$currentLVP.data('model-id');
			var refSkuId = $currentLVP.data('sku-id');
			var customPriceParams = $currentLVP.data('price-params');

			$.ajax({
				type: 'POST', dataType: 'json', url: ajaxURL + superModelId + customParams + customPriceParams,
				success: function(data) {
					var stock = 0;
					// Iterates all Models
					data.responseTO.data.map(function(model) {
						// Iterates all Skus and add availableQuantity
						model.skus.map(function(sku) { if (sku.availableQuantity) stock += sku.availableQuantity; });
					});
					if (stock === 0 && !isDashboard) return removeCurrentLVP($currentLVP);

					// Iterates all Models
					data.responseTO.data.map(function(model) {
						if (model.media === null || model.media.images === null) return false;

						// Iterates on all Skus
						model.skus.filter(function(sku) { return sku.id == refSkuId; }).map(function(sku) {

							refModelId = model.id;

							// Add Product Image
							$currentLVP.find('.slider-products').append(templateSlideProduct(model));

							// Add '.price-container', and display it
							var $priceContainer = $(sku.displayPriceContainer).attr('data-sku-id', sku.id);
							$currentLVP.find('.lvp-product .lvp-price').append($priceContainer);
							$currentLVP.find('.price-container').show();
						});
					});

					// Set DataAttribute for ModelId
					$currentLVP.attr('data-model-id', refModelId);
					$currentLVP.addClass('loaded');

					// Wrap Link around LVP (make LVP clickable)
					_wrapLink($currentLVP);

				}
			});

		},

		loadFullLVP: function() {
			// Remove LVP without URL
			$('.lvp-element[data-default-url="/"]').each(function() { removeCurrentLVP($(this)); });
			var $currentLVP = $(this);
			var refSuperModelId = $currentLVP.data('super-model-id');
			var refModelId = '';//$currentLVP.data('model-id');
			var refSkuId = $currentLVP.data('sku-id');

			if (refSuperModelId == tcVars.product_id_super_model){
				return removeCurrentLVP($currentLVP);
			}

			$.ajax({
				type: 'POST', dataType: 'json', url: ajaxURL + refSuperModelId,
				success: function(data) {
					// Define 'slider-models' as navigation for 'slider-products' (& vice-versa)
					$currentLVP.find('.slider-products').slick('slickSetOption', 'asNavFor', '.lvp-element[data-super-model-id="'+refSuperModelId+'"] .slider-models');
					$currentLVP.find('.slider-models').slick('slickSetOption', 'asNavFor', '.lvp-element[data-super-model-id="'+refSuperModelId+'"] .slider-products');

					var nbModels = data.responseTO.data.filter(function(model) { return model.media !== null; }).length;

					var stock = 0;
					// Iterates all Models
					data.responseTO.data.map(function(model) {
						// Iterates all Skus and add availableQuantity
						model.skus.map(function(sku) { if (sku.availableQuantity) stock += sku.availableQuantity; });
					});
					if (stock === 0){
						return removeCurrentLVP($currentLVP);
					}

					// Iterates all Models
					data.responseTO.data.map(function(model) {

						if (model.media === null || model.media.images === null) return false;

						if (nbModels > 1) {
							// Add 1 model image in '& 'slider-models'
							var isAllSkuUnavailable = model.skus.every(function(sku) { return !sku.available; });
							$currentLVP.find('.slider-models').slick('slickAdd', templateSlideModel(model, isAllSkuUnavailable));
						} else
							$currentLVP.find('.slider-models').hide();

						// Add 1 model image in 'slider-products'
						$currentLVP.find('.slider-products').slick('slickAdd', templateSlideProduct(model));

						// Add 1 sizes-container, transform it in slider
						$currentLVP.find('.lvp-sizes').append(templateSliderSizes(model.id));


						// Init Slick Slider on sliderSize
						var $sliderSize = $currentLVP.find('.slider-sizes[data-model-id="'+model.id+'"]');
						$sliderSize.slick(fwk.perso.lvp.config.slider.slickConfModels);
						$sliderSize.on('beforeChange', sizeBeforeChange);
						$sliderSize.on('afterChange', handleDisableAddToCart);

						// Iterates on all Skus
						model.skus.map(function(sku) {

							// Add 1 'lvp-size'
							$sliderSize.slick('slickAdd', templateSlideSize(sku));

							// Add 1 '.price-container'
							var $priceContainer = $(sku.displayPriceContainer).attr('data-sku-id', sku.id);
							$currentLVP.find('.lvp-price').append($priceContainer);

							// refSku = currentSku => Model Found !
							if (sku.id == refSkuId)
								refModelId = model.id;
						});

					});

					// Set DataAttribute for ModelId
					$currentLVP.attr('data-model-id', refModelId);
					$currentLVP.addClass('loaded');

					// Display good 'slider-sizes', based on refModelId
					var $currentSizes = $currentLVP.find('.slider-sizes[data-model-id="'+refModelId+'"]');
					$currentSizes.show();
					// Display good 'slider-models', based on refModelId
					if (nbModels > 1 && !$('body').hasClass('mobile')) $currentLVP.find('.slider-models .lvp-model[data-model-id="'+refModelId+'"]:not(.slick-cloned)').click();

					// Display the good 'price-container', based on refSkuId
					setTimeout(function() {
						$currentLVP.find('.price-container').hide();
						$currentLVP.find('.price-container[data-sku-id="'+refSkuId+'"]').show();
					}, 100);

					// Go to good size slide (base on skuId)
					// ...with a setTimeout(0) : that will be executed after all current treatment
					var indexSize = $currentLVP.find('.lvp-size[data-sku-id="'+refSkuId+'"]').data('slick-index');
					setTimeout(function() {
						$currentSizes.slick('slickGoTo', indexSize);
						$currentSizes.slick('setPosition');
					}, 0);

 					if ($currentLVP.find('.lvp-size[data-sku-id="'+refSkuId+'"]').hasClass('disabled'))
 						$currentLVP.find('.lvp-btn .cta.cart').addClass('disabled');

					$currentLVP.addClass('direct-add');

					// If we are on checkout / cart > Add 'reresh' class to reload cart on AddToCart
					if (tcVars.page_name === "/checkout/cart")
						$currentLVP.find('.lvp-btn .cta.cart').addClass('refresh');

					// Make LVP clickable, but not for mobile
					if (!$('body').hasClass('mobile'))
						_wrapLink($currentLVP);

					// If product is for store-only : CTA BTN redirect to product page + HIDE Colors & Sizes
					if (!$currentLVP.data('product-sellable-online')) {
						var link = $currentLVP.find('.clickable-area').attr('href');
						$currentLVP.find('.cta-add').wrap('<a href="'+link+'" style="cursor: pointer !important;"></a>');
						$currentLVP.find('.lvp-colors').remove();
						$currentLVP.find('.lvp-sizes').remove();
					}

					setTimeout(function() {
						// Wait for the basic changes (models / sizes selection) to be done
						// then only after, add 'fully-loaded' to the LVP
						// (> avoid useless shoppingtool-colorama updates)
						$currentLVP.addClass('fully-loaded');
					}, 1000);
				}
			});
		},

		config: {
			slider: {
				slickConfGlobal: function(lvpSlickConfig) { return {
					rows:1,
			        infinite: false, dots: true, arrows: false, draggable: false,
					slidesToShow: lvpSlickConfig.amountDesktop, slidesToScroll: lvpSlickConfig.amountDesktop,
			        responsive: [
			            {
			            	breakpoint: decathlon.uxBreakpoints.smMin,
			            	settings: {
			            		slidesToShow: lvpSlickConfig.amountTablet, slidesToScroll: lvpSlickConfig.amountTablet
			            	}
			            },
			            {
			            	breakpoint: decathlon.uxBreakpoints.xsMin,
			            	settings: {
			            		slidesToShow: lvpSlickConfig.amountMobile, slidesToScroll: lvpSlickConfig.amountMobile
			            	}
			            }
			        ]
			    }; },
				slickConfHeadProducts: {
					arrows: false, dots: false,
					slidesToShow: 1, infinite: false, fade: true
				},
				slickConfModels: {
					arrows: true, dots: false, focusOnSelect: true,
					slidesToShow: 1, slidesToScroll: 1, variableWidth: true, infinite: false, centerMode: true
				},
				slickConfSizes: {
					slidesToShow: 1, slidesToScroll: 1, variableWidth: true, infinite: false, centerMode: true,
					draggable: true
				},
			}
		}

	};

	// First : remove the current product from the LVP list
	var removeFloorIfNoLVP = function() {
		var $floor = $('[id*="last-viewed-products"]');
		// If there no more LVP to display, remove LVP FLOOR and link from NAVIGATION BR
		if ($('.lvp-element').length === 0) {
			var linkAnchor = $floor.find('>a').data('dynamic-nav');
			var $linkNavigation = $('a[href="#'+linkAnchor+'"]');

			$floor.remove();
			$linkNavigation.remove();
		}
	};

	/****************************
	 SLICK SLIDERS CONFIGURATION
	*****************************/

	// SLICK - GLOBAL (Responsive)
	var slickConfGlobal = '';

	// SLICK - HEAD PRODUCTS
	var slickConfHeadProducts = '';

	// SLICK - MODELS
	var slickConfModels = '';

	// SLICK - SIZES
	var slickConfSizes = '';


	/**************
	 EVENT HANDLER
	***************/

	// ON CHANGE - MODEL
	// - 1 - Display the good 'slider-sizes'
	// - 2 - Display the good 'price-container'
	var modelBeforeChange = function (event, slick, currentSlide, nextSlide) {

		var $currentLVP = $(this).closest('.lvp-element');
		var modelId = $(slick.$slides.get(nextSlide)).data('model-id');

		// - 1 -
		$currentLVP.find('.lvp-sizes .slider-sizes').hide();
		var $selectedSliderSize = $currentLVP.find('.slider-sizes[data-model-id="'+modelId+'"]');
		$selectedSliderSize.show();
		$selectedSliderSize.slick('setPosition');

		// - 2 -
		var skuId = $selectedSliderSize.find('.slick-current').data('sku-id');
		showPriceContainer($currentLVP, skuId);
		//handleDisableAddToCart($currentLVP, skuId);

		// - 3 - Change URL of 'a.clickable-area'
		var clickableArea = $currentLVP.find('a.clickable-area');
		if (clickableArea.length) {
			var url = clickableArea.attr('href');
			var oldUrlId = url.split('?mc=')[1];
			var newUrl = url.replace(oldUrlId, modelId);
			clickableArea.attr('href', newUrl);
		}
	};

	// ON CHANGE - SIZE
	// - 1 - Display the good 'price-container'
	var sizeBeforeChange = function (event, slick, currentSlide, nextSlide) {

		var $currentLVP = $(this).closest('.lvp-element');
		var skuId = $(slick.$slides.get(nextSlide)).data('sku-id');

		// -1 -
		showPriceContainer($currentLVP, skuId);
		//handleDisableAddToCart($currentLVP, skuId);
	};

	var showPriceContainer = function($currentLVP, skuId) {
		// Do not update price container when LVP slider is refreshing
		if ($('#perso-lvp-list').hasClass('refreshing'))
			return;
		$currentLVP.find('.price-container').hide();
		$currentLVP.find('.price-container[data-sku-id="'+skuId+'"]').show();
	};

	var handleDisableAddToCart = function (event, slick, currentSlide, nextSlide) {

		var $currentLVP = $(this).closest('.lvp-element');
		var isSizeDisabled = false;

		var selectedModel = $currentLVP.find('.slider-models .slick-current').data('model-id');

		if (selectedModel)
 			isSizeDisabled = $currentLVP.find('.slider-sizes[data-model-id="'+selectedModel+'"] .slick-current').hasClass('disabled');
 		else
 			isSizeDisabled = $currentLVP.find('.slider-sizes .slick-current').hasClass('disabled');

		var productSellableOnLine = $currentLVP.data('product-sellable-online');

		if (isSizeDisabled || !productSellableOnLine)
			$currentLVP.find('.lvp-btn .cta.cart').addClass('disabled');
		else {
			$currentLVP.find('.lvp-btn .cta.cart').removeClass('disabled');
		}
	};

	var _wrapLink = function($currentLVP) {

		var url = $currentLVP.data('default-url');

		// TODO - WARNING - Special workaround for new locale URL
		if (window.location.href.indexOf('/nl/') === -1){
			url = url.replace('/nl/', '/');
		}

		var target = (lvpConfig.targetBlank) ? ' target="_blank" rel="noopener" ' : '';
		var link = '<a data-tnr-plv-element-link-' + $currentLVP.index() + ' class="clickable-area" href="' + url + '" '+target+'></a>';

		// Add Link
		$currentLVP.find('.lvp-product')
					.wrap(link);

		// Change cursor to pointer
		$currentLVP.find('.lvp-product').css('cursor', 'pointer');
	};

	var removeCurrentLVP = function($currentLVP) {

		var $floor = $currentLVP.closest('section');

		// Search LVP Index and remove it from slider
		var index = $currentLVP.closest('.slick-slider').find('.lvp-element').index($currentLVP);
		$currentLVP.closest('.slick-slider').slick('slickRemove', index);

		// Load the new displayed LVP (if any)
		$('.lvp-element.slick-active.new').removeClass('new').each(fwk.perso.lvp.fetchLVP());

		removeFloorIfNoLVP();
	};


	/**********
	 TEMPLATES
	***********/

	// TEMPLATE - SLIDE HEAD PRODUCT
	var templateSlideProduct = function(model) {

    	var idModel = model.id;
    	var name = model.media.images[0].name;
      var url = model.media.images[0].url;
      var wepbIsActive = true;

      return '<div class="lvp-product-img" role="radio" data-model-id="' + idModel + '">' +
        '<picture alt="' + name + '" aria-hidden="true">' +
          (wepbIsActive ? '<source type="image/webp" srcset="' + url.replace('jpg', 'webp').replace('jpeg', 'webp') + '?f=250x250">':'') +
            '<source type="image/jpeg" srcset="' + url + '?f=250x250">' +
             '<img src="'+url+'?f=250x250" alt="' + name + '" alt="' + name + '">' +
             '</picture>' +
          '</div>';
	};

	// TEMPLATE - SLIDE MODEL
	var templateSlideModel = function(model, isUnvailable) {

    	var idModel = model.id;
    	var name = model.media.images[0].name;
      var url = model.media.images[0].url;
      var wepbIsActive = true;

		return '<div class="lvp-color lvp-model '+(isUnvailable ? 'unavailable' : '')+'" role="radio" data-model-id="' + idModel + '">' +
        '<picture alt="' + name + '" aria-hidden="true">' +
            (wepbIsActive ? '<source type="image/webp" srcset="' + url.replace('jpg', 'webp').replace('jpeg', 'webp') + '?f=250x250">':'') +
            '<source type="image/jpeg" srcset="' + url + '?f=250x250">' +
             '<img src="'+url+'?f=250x250" alt="' + name + '" style="height: 40px;">' +
             '</picture>' +
          '</div>';
	};

	// TEMPLATE - SLIDER SIZES (container)
	var templateSliderSizes = function(idModel) {
		return '<div class="size-content"><div class="lvp-sizes-container slider-sizes medium contour" data-model-id="' + idModel + '"></div></div>';
	};

	// TEMPLATE - SLIDE SIZE
	var templateSlideSize = function(sku) {
		return '<div class="lvp-size '+ (sku.available ? '' : 'disabled') +'" data-sku-id="' + sku.id + '">' + sku.size + '</div>';
	};

	// Initialisation on scroll (when we reach LVP Floor - 250 px)
	var $watchOnScroll = $('[id*="last-viewed-products"],.dash-card.last-products');
	if ($watchOnScroll.length > 0) {

		// If an element is watchable : check if its visible, then trigger LVP Init (once)
		var alreadyInit = false;
		$(window).on('scroll', cube.debounce(function() {
			if (fwk.Anly.utils.isVisible($watchOnScroll, 250) && !alreadyInit) {
				alreadyInit = true;
				fwk.perso.lvp.init();
			}
		}, 150));

		// Trigger a 'scroll' event to load LVP on page init (if in viewport)
		$(window).trigger('scroll');
	}

	var updateAllSubSliders = function() {

		if (!$('#perso-lvp-list').length)
			return;

		$('#perso-lvp-list').addClass('refreshing');

		// Update sliders for MODELS
		$('.lvp-colors.slick-slider').each(function() {
			var $current = $(this);
			$current.slick('slickGoTo', $current.slick('slickCurrentSlide'));
		});

		// Update sliders for PRODUCTS (SKU)
		$('.lvp-sizes .slick-slider').each(function() {
			var $current = $(this);
			$current.slick('slickGoTo', $current.slick('slickCurrentSlide'));
			if ($current.find('.slick-slide').length === 1)
				$current.find('.slick-slide').addClass('slick-current');
		});

		setTimeout(function() {
			$('#perso-lvp-list').removeClass('refreshing');
		}, 1000);
	};

	var currentSuperModel = tcVars.product_id_super_model;
	$('.lvp-element[data-super-model-id="'+currentSuperModel+'"]').remove();
	removeFloorIfNoLVP();

	if ($('#perso-lvp-grid').length) fwk.perso.lvp.init();

  window.CUBE = Object.assign(window.CUBE || {}, fwk);

})(jQuery);



// WEBPACK FOOTER //
// ./src/analytics/transcript-workaround/lvp.js